import React, { useRef, useState } from 'react';
import { Container, Grid, Typography, Button, Box, TextField, useMediaQuery, Divider, List, ListItem, ListItemIcon, ListItemText, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { styled } from '@mui/system';
import BuzzHeader from '../Header/BuzzHeader'
import { API_URL, BASE_URL } from '../ApiConfig';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


const DownloadButton = styled(Box)({
    padding: '8px 35px',
    borderRadius: '3px',
    border: "1px solid #303030",
    cursor: 'pointer',
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
    alignSelf: 'center',
    marginTop: 25
});

const HeroSection = () => {

    const navigate = useNavigate()
    const sectionRef = useRef(null)

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };


    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:900px)')
    return (
        <Box sx={{
            flexDirection: 'column', alignItems: 'center', alignSelf: 'stretch', display: 'flex', minHeight: "200px",

        }}>

            <Box ref={sectionRef} sx={{
                width: "100%", position: 'relative',
                display: 'flex', flexDirection: 'column'
            }}>

                <Box sx={{ pt: 15, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    <Typography fontFamily={"poppins"} fontWeight={600} mx={"50px"} variant={isMobileScreen ? "h5" : "h4"} component="h2" gutterBottom textAlign="center">
                        Register for the upcoming campus feed
                    </Typography>

                    <PreRegistrationForm />

                    <Box sx={{
                        flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: "60px", alignSelf: 'stretch', background: '#363636',
                        justifyContent: 'center', paddingY: "15px",
                    }}>
                        <Typography sx={{ color: '#ffffff90', fontFamily: 'poppins', fontWeight: 300, fontSize: "12px", }}>
                            Copyright © 2025. Powered by </Typography>

                        <img style={{ width: "70px", height: "50px", marginLeft: "5px", filter: 'invert()' }} src={require("../../assets/images/vb_logo.svg")} />
                    </Box>

                </Box>

            </Box>

        </Box>
    );
};

const PreRegistrationForm = React.forwardRef((props, ref) => {

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1150px)')

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [mobile, setMobile] = useState('')
    const [department, setDepartment] = useState('')
    const [year, setYear] = useState('')
    const [club, setClub] = useState('')
    const [clubDetails, setClubDetails] = useState("")
    const [joinCrew, setJoinCrew] = useState("")
    const [college, setCollege] = useState("")



    const submitDetails = async () => {
        try {

            if (name == "") {
                alert("Please enter your full name")
            } else if (college == "") {
                alert("Please enter your college or university name")
            } else if (mobile == "") {
                alert("Please enter your mobile number")
            } else if (email == "") {
                alert("Please enter your campus email address")
            } else if (department == "") {
                alert("Please enter your department")
            } else if (year == "") {
                alert("Please enter your year of study")
            } else if (club == "Yes" && clubDetails == "") {

                alert("Please specify the club details")

            } else {

                const clubMember = (club == "Yes") ? `${club}\n${clubDetails}` : "No"
                const crewJoin = joinCrew == "Yes" ? "Yes" : "No"

                const response = await fetch(`${API_URL}/web/buzzonspot/pre-register`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ name, email, mobile, department, year, crewJoin, clubMember, college })
                });

                const json = await response.json();

                if (json.success) {
                    // Handle successful submission (e.g., display a success message)
                    alert(json.response);
                    setName("")
                    setEmail("")
                    setMobile("")
                    setCollege("")
                    setMessage("")
                    setDepartment("")
                    setYear("")
                    setClub("")
                    setClubDetails('')
                    setJoinCrew("")
                } else {
                    // Handle errors (e.g., display an error message)
                    alert(json.response);
                }
            }
        } catch (error) {
            console.log('Error:', error);
            alert('An unexpected error occurred. Please try again later.');
        }
    };

    return (
        <Box ref={ref} sx={{
            flexDirection: 'column', display: 'flex', background: '#ffffff', borderRadius: "15px", padding: isMobileScreen ? "15px" : "25px", alignSelf: 'center',
            marginInline: isMobileScreen ? "10px" : "0px", width: isMobileScreen ? "90%" : isTabScreen ? "400px" : "500px",
            marginTop: "20px", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
        }}>

            <Typography style={{ fontFamily: 'poppins', fontWeight: 500, fontSize: "12px", color: "#303030", marginLeft: "3px", marginTop: "10px" }}>Name <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px", alignSelf: 'stretch'
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'text'}
                placeholder='Enter your full name'
            />


            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>Phone number <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'tel'}
                placeholder='Enter your phone number'
            />

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>College or University Name <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={college}
                onChange={(e) => setCollege(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'text'}
                placeholder='Enter your college or university name'
            />

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>College Email Id <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'email'}
                placeholder='Enter student mail of your campus'
            />

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>Department <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'text'}
                placeholder='Your department in campus'
            />

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>Year <span style={{ color: 'red' }}>*</span></Typography>
            <TextField
                value={year}
                onChange={(e) => setYear(e.target.value)}
                style={{
                    borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                }}
                inputProps={{
                    style: {
                        paddingTop: "13px", paddingBottom: "13px", paddingInline: "15px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                    }
                }}
                inputMode={'text'}
                placeholder='Enter your year of study'
            />

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>Are you part of any clubs/societies?</Typography>

            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={club}
                    onChange={(event) => {
                        setClub(event.target.value)
                    }}
                    sx={{ fontFamily: "Poppins", marginInline: "2px" }}
                    name="radio-buttons-group"
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio sx={{
                            '& .MuiSvgIcon-root': {
                                fontSize: 17,
                            },
                        }} />}
                        label={<Typography style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "14px" }} color="#303030">Yes</Typography>}
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio sx={{
                            '& .MuiSvgIcon-root': {
                                fontSize: 17,
                            },
                        }} />}
                        label={<Typography style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "14px" }} color="#303030">No</Typography>}
                        sx={{ fontFamily: 'Poppins' }}
                    />
                </RadioGroup>
            </FormControl>

            {
                club == "Yes" && (
                    <TextField
                        error={club == "Yes" && clubDetails == ""}
                        value={clubDetails}
                        onChange={(e) => setClubDetails(e.target.value)}
                        style={{
                            borderColor: '#ffffff', background: '#ffffff', borderRadius: "4px", marginTop: "5px",
                            verticalAlign: 'top', textAlign: 'left', flex: 1,
                        }}
                        inputProps={{
                            style: {
                                paddingTop: "0px", paddingBottom: "13px", borderRadius: "4px", fontFamily: 'poppins', fontSize: '14px',
                                textAlign: 'left', verticalAlign: 'top', minHeight: "90px"
                            }
                        }}
                        multiline
                        placeholder='Please specify the club details'
                    />
                )
            }

            <Typography style={{
                fontFamily: 'poppins', fontWeight: 500, fontSize: "13px", color: "#303030", marginLeft: "3px",
                marginTop: "20px"
            }}>Interested in joining the Buzz Campus Crew?</Typography>

            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={joinCrew}
                    onChange={(event) => {
                        setJoinCrew(event.target.value)
                    }}
                    sx={{ fontFamily: "Poppins", marginInline: "2px" }}
                    name="radio-buttons-group"
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio sx={{
                            '& .MuiSvgIcon-root': {
                                fontSize: 17,
                            },
                        }} />}
                        label={<Typography style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "14px" }} color="#303030">Yes</Typography>}
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio sx={{
                            '& .MuiSvgIcon-root': {
                                fontSize: 17,
                            },
                        }} />}
                        label={<Typography style={{ fontFamily: "poppins", fontWeight: 500, fontSize: "14px" }} color="#303030">No</Typography>}
                        sx={{ fontFamily: 'Poppins' }}
                    />
                </RadioGroup>
            </FormControl>


            <Typography
                onClick={submitDetails}
                style={{
                    cursor: 'pointer',
                    color: '#ffffff', fontFamily: 'poppins', fontSize: "14px", background: '#333946', borderRadius: "4px", fontWeight: 500,
                    marginTop: "40px", textAlign: 'center', paddingBottom: "10px", paddingTop: "10px"
                }}
            >
                Submit Details
            </Typography>

        </Box>
    )
})






const PreRegistration = () => {

    return (
        <>
            <Helmet>
                <title>Cerkle Pre Registrations</title>
                <meta name="description" content="Join the coolest group of folks on Campus and unlock a world of in the moment possibilities with Cerkle" />
                <meta name="keywords" content="Buzz, Cerkle, Crew, Community, Fun" />
                <meta property="og:title" content="Cerkle Pre Registration" />
                <meta property="og:description" content="Join the coolest group of folks on Campus and unlock a world of in the moment possibilities with Cerkle" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/buzz-dev-1.appspot.com/o/cerkle_logo_new.png?alt=media&token=2ab31e6d-9c11-4e4e-9cd9-3032776872a6" />
                <meta property="og:url" content="https://vybecerkle.com/pre-registration" />
            </Helmet>
            <BuzzHeader isAppButton onSelect={(pos) => {
                window.location.href = `${BASE_URL}`
            }} />
            <Box sx={{ height: "1px", alignSelf: 'stretch', background: '#aaaaaa20' }} />
            <HeroSection />
        </>
    );
};

export default PreRegistration;
